<template>
  <div class="core">
    <div class="layui-layer-title" style="cursor: move;"></div>
    <div class="layui-layer-content">
      <div class="layui-layer-wrap">
        <div class="form-collapse">
          <div class="info">
            <layui-form ref="managerForm" :rule="form_rule" :requestUniqueId="requestId">
              <template slot-scope="{ scope }">
                <div class="layui-form">
                  <template>
                    <layui-collapse>
                      <div class="layui-colla-item">
                        <h2 class="layui-colla-title">项目经理基本信息</h2>
                        <div class="layui-colla-content layui-show">
                          <div class="layui-form-item-one">
                            <div class="layui-form-item" v-if="formType !== 'add'">
                              <label class="layui-form-label">项目经理编号：</label>
                              <div class="layui-input-inline">
                                <input
                                  type="text"
                                  :disabled="formType !== 'add' ? true : false "
                                  v-model="config.form.MANAGER_BH"
                                  autocomplete="off"
                                  class="layui-input layui-disabled"
                                  name="MANAGER_BH"
                                  placeholder="请输入项目经理编号"
                                />
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label"><span class="x-red">*</span>项目经理姓名：</label>
                              <div class="layui-input-inline">
                                <input
                                  type="text"
                                  :disabled="disabledVisible"
                                  v-model="config.form.MANAGER_NAME"
                                  autocomplete="off"
                                  :class="disabledVisible ? 'layui-input layui-disabled': 'layui-input'"
                                  name="MANAGER_NAME"
                                  placeholder="项目经理姓名"
                                />
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label"><span class="x-red">*</span>联系电话：</label>
                              <div class="layui-input-inline">
                                <input
                                  type="text"
                                  v-model="config.form.MANAGER_PHONE"
                                  :disabled="disabledVisible"
                                  autocomplete="off"
                                  :class="disabledVisible ? 'layui-input layui-disabled': 'layui-input'"
                                  name="MANAGER_PHONE"
                                  placeholder="请输入联系电话"
                                />
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label"><span class="x-red">*</span>所属地：</label>
                              <div class="layui-input-inline">
                                <!-- <layui-zqselect
                                  ref="areaRef"
                                  v-model="config.form.SSD"
                                  :maxLoadLevel="3"
                                  :maxWidth="600"
                                  :enabled="!disabledVisible"
                                  :class="disabledVisible ? 'layui-disabled': ''"
                                  placeholder = "请选择政区"
                                >
                                </layui-zqselect> -->
                                <region-select
                                  ref="ssd"
                                  v-model="config.form.SSD"
                                  @change="change"
                                  :enabled="!disabledVisible"
                                ></region-select>
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">地址：</label>
                              <div class="layui-input-inline">
                                <input
                                  type="text"
                                  v-model="config.form.ADDRESS"
                                  :disabled="disabledVisible"
                                  autocomplete="off"
                                  :class="disabledVisible ? 'layui-input layui-disabled': 'layui-input'"
                                  name="ADDRESS"
                                  placeholder="请输入地址"
                                />
                              </div>
                            </div>
                            <div class="layui-form-item">
                              <label class="layui-form-label">备注：</label>
                              <div class="layui-input-inline">
                                <textarea v-model="config.form.BZ" :class="disabledVisible ? 'layui-textarea layui-disabled': 'layui-textarea'"></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </layui-collapse>
                    <layui-collapse v-show='disabledVisible'>
                      <div class="layui-colla-item">
                        <h2 class="layui-colla-title">客户信息</h2>
                        <div class="layui-colla-content layui-show inside-table" >
                          <layui-table
                            ref="customerInfo"
                            table-name='YW_BRAND_DETAIL_V'
                            :lazy="true"
                            :page-size="20"
                            :page-range="6"
                            :page-options="[10, 20, 50, 100]"
                            :skin="'line'"
                            height="320"
                          >
                            <div>
                              <div field="MANAGER_NAME" title="项目经理"></div>
                              <div field="CLIENT_NAME" title="客户"></div>
                              <div field="BRAND_NAME" title="品牌"></div>
                              <div field="CREATE_TIME" title="创建时间"></div>
                            </div>
                          </layui-table>
                        </div>
                      </div>
                    </layui-collapse>
                  </template>
                </div>
                <div class="layui-form-btn">
                  <div class="layui-footer">
                    <button class="layui-btn refresh" title="关闭" @click="handleBtnclick('close')">
                      关 闭
                    </button>
                    <button  v-if='!disabledVisible' class="layui-btn" title="保存" @click="handleBtnclick('save')">
                      保 存
                    </button>
                  </div>
                </div>
              </template>
            </layui-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    formType: {
      type: String,
      default: () => ''
    },
    formData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      disabledVisible: false,
      requestId: 'managerRequest',
      form_rule: {
        MANAGER_NAME: {
          required: { message: '项目经理姓名不能为空' }
        },
        MANAGER_PHONE: {
          required: { message: '联系电话不能为空' }
        },
        SSD: {
          required: { message: '所属地不能为空' }
        }
      },
      config: {
        form: {},
      }
    }
  },
  mounted() {
    // 解决 展开收起后的样式问题
    $('.layui-colla-item').on('click', function() {
      var othis = $(this),
        elemCont = othis.children('.layui-colla-title'),
        elemCont1 = othis.children('.layui-colla-content'),
        isNone = elemCont1.css('display') === 'none'
      if (isNone) {
        elemCont.css('border-radius', '8px')
      } else {
        elemCont.css('border-radius', '8px 8px 0px 0px')
      }
    })
    this.$nextTick(() => {
      if (this.formType === 'edit') {
        this.$refs.managerForm.openWin('编辑', this.close_callBack)
        if(!Array.isArray(this.formData.SSD)){
          this.formData.SSD = this.formData.SSD.split(',')

          if (!this.formData.SSD[this.formData.SSD.length - 1]) {
            this.formData.SSD.pop()
          }
        }
        this.config.form = this.formData
      }  else if(this.formType === 'check'){
        this.$refs.managerForm.openWin('查看', this.close_callBack)
        if(!Array.isArray(this.formData.SSD)){
          this.formData.SSD = this.formData.SSD.split(',')

          if (!this.formData.SSD[this.formData.SSD.length - 1]) {
            this.formData.SSD.pop()
          }
        }

        this.config.form = this.formData
        this.disabledVisible = true
        this.$refs.customerInfo.queryObject = {MANAGER_ID: this.formData.MANAGER_ID}
        this.$refs.customerInfo.load()
      } else {
        this.$refs.managerForm.openWin('新增项目经理', this.close_callBack)
      }
    })
  },
  methods: {
    change(val,fn){
      let arr = []
      let arrText = []
      fn.forEach(item=>{
        arr.push(item.id)
        arrText.push(item.text)
      })
      this.areaArr = arr
      this.areaArrText = arrText
      this.config.form.PROVINCE = this.areaArr[0] ? this.areaArr[0] : '';
      this.config.form.CITY = this.areaArr[1] ? this.areaArr[1] : '';
      this.config.form.DISTRICT = this.areaArr[2] ? this.areaArr[2] : '';
    },
    /**
     * form弹窗关闭的回调
     */
    close_callBack() {
      this.$emit('update:visible', false)
    },
    /**
     * 保存、重置
     */
    handleBtnclick(type) {
      switch (type) {
        case 'close': {
          this.$emit('update:visible', false)
          break
        }
        case 'save': {
          let arr = null
          if (!this.config.form.SSD || this.config.form.SSD.length === 0) {
            layer.msg('所属地不能为空', {icon: 5,shift: 6});
            return
          }
          this.$refs.managerForm.editRow = this.config.form
          this.config.form.SSX = this.arrText
          this.$refs.managerForm.save(this.$parent.$refs.manager)
          break
        }
        default: {
          break
        }
      }
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/person/projectManager/managerForm.vue